import type { UserConsentManagementModel } from "@akte-mord/common";

export const GROUPS: UserConsentManagementModel.Group[] = [
  {
    id: "essential",
    description:
      "Essenzielle Cookies und Datenverarbeitungen ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.",
    name: "Essenziell",
    required: true,
  },
  {
    id: "analytics",
    description:
      "Statistische Cookies und Datenverarbeitungen erfassen Informationen anonym. Diese Informationen helfen uns als Betreiber zu verstehen, wie Besucher unsere Angebote nutzen.",
    name: "Statistiken",
    required: false,
  },
  {
    id: "external-media",
    description:
      "Inhalte von Videoplattformen und Social Media Plattformen werden standardmäßig blockiert. Wenn Cookies von externen Medien akzeptiert werden, bedarf der Zugriff auf diese Inhalte keiner manuellen Zustimmung mehr.",
    name: "Externe Medien",
    required: false,
  },
];

export const PROCESSES: UserConsentManagementModel.Process[] = [
  {
    group: "essential",
    id: "consent",
    name: "Datenschutz-Einstellungen",
    privacyPolicyUrl: "/datenschutzerklaerung",
    provider: "Bischoff, Kauffmann & Otani GbR",
    purpose: "Speichert die Datenschutz-Einstellungen der Besucher.",
    required: true,
  },
  {
    group: "essential",
    id: "shop",
    name: "Warenkorb",
    privacyPolicyUrl: "/datenschutzerklaerung",
    provider: "Bischoff, Kauffmann & Otani GbR",
    purpose:
      "Stellt die Warenkorb Funktionalität zur Verfügung, speichert die Session mit den in den Warenkorb gelegten Waren und dem Checkout-Status",
    required: true,
  },
  {
    group: "analytics",
    id: "google-analytics",
    name: "Google Analytics",
    privacyPolicyUrl: "https://policies.google.com/privacy",
    provider: "Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland",
    purpose:
      "Cookie von Google für Website-Analysen. Erzeugt statistische Daten darüber, wie der Besucher die Website nutzt.",
    required: false,
  },
  {
    group: "external-media",
    id: "google-maps",
    name: "Google Maps",
    provider: "Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland",
    purpose: "Wird zum Entsperren von Google Maps-Inhalten verwendet.",
    privacyPolicyUrl: "https://policies.google.com/privacy",
    required: false,
  },
  {
    group: "external-media",
    id: "youtube",
    name: "YouTube",
    provider: "Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland",
    purpose: "Wird zum Entsperren von YouTube-Inhalten verwendet.",
    privacyPolicyUrl: "https://policies.google.com/privacy",
    required: false,
  },
];
